const DELAY = 750; // ms

// This is used for lazy fetching data of secondary importance for page rendering.
export default function lazyFetch(fetchFnc) {
  return setTimeout(fetchFnc, DELAY);
}
